import { useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '~/firebase/init';

import authAtom from '~/recoil/atom/auth';
import authStatusAtom from '~/recoil/atom/authStatus';
import { useSetRecoilState } from 'recoil';

import { FirebaseDataStatus } from '~/types/utilities';

export default function useAuth() {
  const setAuth = useSetRecoilState(authAtom);
  const setAuthStatus = useSetRecoilState(authStatusAtom);

  useEffect(() => {
    const unlisten = onAuthStateChanged(
      auth,
      (auth) => {
        setAuth(auth);
        setAuthStatus(auth ? FirebaseDataStatus.EXIST : FirebaseDataStatus.NOT_EXIST);
      },
      (err) => {
        console.error('auth listener fail', err);
      },
    );

    return () => {
      unlisten();
    };
  }, []);
}
